import { render, staticRenderFns } from "./garlic_ctl_dise.vue?vue&type=template&id=1d576e54&"
import script from "./garlic_ctl_dise.vue?vue&type=script&lang=js&"
export * from "./garlic_ctl_dise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports